/* eslint-disable indent */
// import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useEffect, useMemo, useState } from 'react';
import { useForm, useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useParams, useSearchParams } from 'react-router-dom';
import ReactRouterPrompt from 'react-router-prompt';
import { getDetail, getGeneralProjectProposalInfo } from 'apis/prequalificationReviews.api';
import {
  DynamicPrequalificationForm,
  PrequalificationForm,
} from 'features/PrequalificationReview/components';
import { is1593 } from 'utils/func';

export default function PrequalificationReviewFormDetail() {
  const { t } = useTranslation();
  const [isVisibleErrorDialog, setIsVisibleDialogError] = useState(false);
  const { projectProposalId } = useParams();
  const [searchParams] = useSearchParams();
  const councilId = searchParams.get('councilId');
  const councilMemberId = searchParams.get('councilMemberId');

  const { data: dataGeneralProjectProposalInfo, isLoading: isLoadingProjectProposal } = useQuery(
    ['prequalification-review', 'project-proposal', councilId, projectProposalId],
    ({ queryKey: [, , _councilId, _projectProposalId] }) =>
      getGeneralProjectProposalInfo(_councilId, _projectProposalId)
  );

  const {
    data: _data,
    isLoading: isLoadingPrequalificationReview,
    // refetch: refetchPrequalificationReview,
  } = useQuery(
    ['prequalification-review', 'detail', councilMemberId, councilId, projectProposalId],
    ({ queryKey: [, , _councilMemberId, _councilId, _projectProposalId] }) =>
      getDetail(_councilMemberId, _councilId, _projectProposalId)
  );

  const prequalificationReviewData = useMemo(() => _data?.data ?? {}, [_data]);
  const prequalificationReview = useMemo(
    () => prequalificationReviewData?.prequalificationReview || {},
    [prequalificationReviewData]
  );
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    getValues,
    formState: {
      errors,
      // , isValid
    },
  } = useForm({
    mode: 'onChange',
    // resolver: yupResolver(createMidtermReviewValidationSchema),
  });
  const { isDirty, dirtyFields } = useFormState({ control });
  useEffect(() => {
    if (prequalificationReview) {
      reset(prequalificationReview);
      setValue(
        'isNotQualified',
        prequalificationReview?.generalEvaluate != null && !prequalificationReview?.generalEvaluate
      );
      setValue('otherOpinionTickbox', !!prequalificationReview?.otherOpinion);
    }
  }, [prequalificationReviewData]);

  const footerConfirmationPrompt = (onConfirm, onCancel) => (
    <div>
      <Button
        label={t('formLayout.action.cancel')}
        className="w-7rem"
        severity="danger"
        onClick={onCancel}
        autoFocus
      />
      <Button
        label={t('formLayout.action.ok')}
        className="w-7rem"
        severity="info"
        onClick={onConfirm}
      />
    </div>
  );

  const template = useMemo(
    () => parseInt(dataGeneralProjectProposalInfo?.data?.template, 10) || null,
    [dataGeneralProjectProposalInfo]
  );

  const renderFirstTab = () => {
    if (is1593(template) || isLoadingProjectProposal) {
      return (
        <DynamicPrequalificationForm
          projectProposalId={projectProposalId}
          councilId={councilId}
          councilMemberId={councilMemberId}
          generalInfo={dataGeneralProjectProposalInfo?.data}
          isLoading={isLoadingProjectProposal}
          readOnly
        />
      );
    }
    return (
      <PrequalificationForm
        isCreateForm
        isLoading={isLoadingProjectProposal || isLoadingPrequalificationReview}
        handleSubmit={handleSubmit}
        control={control}
        watch={watch}
        setValue={setValue}
        getValues={getValues}
        isDirty={isDirty}
        dirtyFields={dirtyFields}
        errors={errors}
        isValid
        isVisibleErrorDialog={isVisibleErrorDialog}
        setIsVisibleDialogError={setIsVisibleDialogError}
        dataGeneralProjectProposalInfo={dataGeneralProjectProposalInfo}
      />
    );
  };
  // #endregion

  return (
    <>
      <ReactRouterPrompt when={isDirty && Object.keys(dirtyFields).length}>
        {({ isActive, onConfirm, onCancel }) => (
          <Dialog
            visible={isActive}
            header={<p className="text-blue-500">{t('projectProposal.confirmationTitle')}</p>}
            position="center"
            style={{ width: '300px' }}
            onHide={onCancel}
            draggable={false}
            footer={() => footerConfirmationPrompt(onConfirm, onCancel)}
          >
            <p className="text-lg py-3">{t('projectProposal.confirmationPromptMessage')}</p>
          </Dialog>
        )}
      </ReactRouterPrompt>
      {renderFirstTab()}
    </>
  );
}
